import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Preloader from "./components/effects/Preloader";
import CustomCursor from "./components/effects/CustomCursor";
import CommandPalette from "./components/effects/CommandPalette";
import RouteExperience from "./components/effects/RouteExperience";
import NovaChat from "./components/NovaChat";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import Portfolio from "./pages/Portfolio";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Careers from "./pages/Careers";
import FAQ from "./pages/FAQ";
import Booking from "./pages/Booking";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

export default function App() {
  const [palette, setPalette] = useState(false);

  return (
    <div className="App">
      <Preloader />
      <CustomCursor />
      <BrowserRouter>
        <RouteExperience />
        <CommandPalette open={palette} setOpen={setPalette} />
        <Routes>
          <Route path="/" element={<Home onOpenPalette={() => setPalette(true)} />} />
          <Route path="/services" element={<Services onOpenPalette={() => setPalette(true)} />} />
          <Route path="/capabilities" element={<Services onOpenPalette={() => setPalette(true)} />} />
          <Route path="/pricing" element={<Pricing onOpenPalette={() => setPalette(true)} />} />
          <Route path="/case-studies" element={<Portfolio onOpenPalette={() => setPalette(true)} />} />
          <Route path="/the-archive" element={<Portfolio onOpenPalette={() => setPalette(true)} />} />
          <Route path="/about" element={<About onOpenPalette={() => setPalette(true)} />} />
          <Route path="/the-transmission" element={<About onOpenPalette={() => setPalette(true)} />} />
          <Route path="/blog" element={<Blog onOpenPalette={() => setPalette(true)} />} />
          <Route path="/the-observatory" element={<Blog onOpenPalette={() => setPalette(true)} />} />
          <Route path="/blog/:slug" element={<BlogPost onOpenPalette={() => setPalette(true)} />} />
          <Route path="/the-observatory/:slug" element={<BlogPost onOpenPalette={() => setPalette(true)} />} />
          <Route path="/careers" element={<Careers onOpenPalette={() => setPalette(true)} />} />
          <Route path="/faq" element={<FAQ onOpenPalette={() => setPalette(true)} />} />
          <Route path="/book" element={<Booking onOpenPalette={() => setPalette(true)} />} />
          <Route path="/consultation" element={<Booking onOpenPalette={() => setPalette(true)} />} />
          <Route path="/contact" element={<Contact onOpenPalette={() => setPalette(true)} />} />
          <Route path="/mission-control" element={<Contact onOpenPalette={() => setPalette(true)} />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
        <NovaChat />
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}
